import Vue from 'vue'
import App from './Download.vue'
import {DownloadRouter} from './router'
import {installGoogleAnalytics} from "@/components/Analytics";

installGoogleAnalytics();
Vue.config.productionTip = false

new Vue({
  router: DownloadRouter,
  render: h => h(App)
}).$mount('#app')
